export default __webpack_public_path__ + "static/media/error.45804ade.svg";